import { CandidateCitySelect } from '@widgets/candidate/candidate-city-select';
import { Button, Flex, Paper, Text, Title } from '@mantine/core';
import { formatPhoneNumber } from '@shared/helpers';
import { IconPencil } from '@tabler/icons-react';

type CandidatePrivateDataCardProps = {
  allCities?: boolean;
  lastName?: string | null;
  age?: string | null;
  cityIds?: number[];
  educationLevel?: string | null;
  firstName?: string | null;
  generalInfo?: string | null;
  phone?: string;
  preferredCommunicationLanguage?: string | null;
  professionName?: string | null;
  onEdit: () => void;
};

export const CandidatePrivateDataCard = ({
  allCities = false,
  lastName = '-',
  age = '-',
  cityIds = [],
  educationLevel = '-',
  firstName = '-',
  generalInfo = '-',
  phone = '-',
  preferredCommunicationLanguage = '-',
  professionName = '-',
  onEdit,
}: CandidatePrivateDataCardProps) => (
  <Paper p={24} radius={16} bg='primary.0' w='100%' maw={1070}>
    <Flex gap={24} direction='column'>
      <Flex w='100%' justify='space-between' wrap='wrap'>
        <Title order={4}>Основная информация</Title>

        <Button
          variant='subtle'
          size='md'
          leftSection={<IconPencil size={20} />}
          onClick={onEdit}
        >
          Редактировать
        </Button>
      </Flex>

      <Flex gap={24} wrap={{ base: 'wrap', sm: 'nowrap' }} w='100%'>
        <Flex direction='column' gap={24} flex='1 1 50%'>
          <DataField label='Фамилия' value={lastName} />
          <DataField label='Возраст' value={age} />
          <DataField label='Уровень образования' value={educationLevel} />
          <Flex direction='column' gap={8}>
            <Text c='tertiary.7' size='sm'>
              Город
            </Text>
            <CandidateCitySelect
              mode='card'
              allCities={allCities}
              cityIds={cityIds}
            />
          </Flex>
        </Flex>

        <Flex direction='column' gap={24} flex='1 1 50%'>
          <DataField label='Имя' value={firstName} />
          <DataField
            label='Контактный телефон'
            value={formatPhoneNumber(phone)}
          />
          <DataField label='Специальность' value={professionName} />
          <DataField
            label='Язык общения'
            value={preferredCommunicationLanguage}
          />
        </Flex>
      </Flex>

      <DataField label='Общая информация' value={generalInfo} />
    </Flex>
  </Paper>
);

type DataFieldProps = {
  label: string;
  value?: string | null;
};

const DataField = ({ label, value }: DataFieldProps) => (
  <Flex direction='column' gap={8}>
    <Text c='tertiary.7' size='sm'>
      {label}
    </Text>
    <Text c='primary.7' style={{ whiteSpace: 'pre-wrap' }}>
      {value || '-'}
    </Text>
  </Flex>
);
